<template>
  <div ref="dropdownRef">
    <a
      class="text-blueGray-500 block"
      href="#pablo"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <div class="items-center flex">
        <span
          class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full"
        >
          <img
            alt="..."
            class="w-full rounded-full align-middle border-none shadow-lg"
            :src="userInfo.avatar"
          />
        </span>
      </div>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <!-- 用户信息 -->
      <div class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 border-b border-gray-200">
        <div class="font-semibold">{{ userInfo.username }}</div>
        <div class="text-xs text-gray-500">{{ userInfo.email }}</div>
      </div>

      <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-red-600 hover:bg-red-50"
        @click="handleLogout"
      >
        <i class="fas fa-sign-out-alt mr-2"></i>
        退出登录
      </a>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";
import { getUserInfo, clearUserLogin } from "@/utils/auth.js";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
      userInfo: {
        username: 'Admin',
        email: 'admin@example.com',
        avatar: "",
      }
    };
  },
  mounted() {
    // 获取用户信息
    const userInfo = getUserInfo();
    if (userInfo) {
      this.userInfo = userInfo;
    }
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
    handleClickOutside(event) {
      if (!this.dropdownPopoverShow) {
        return;
      }
      const dropdown = this.$refs.dropdownRef;
      if (dropdown && !dropdown.contains(event.target)) {
        this.dropdownPopoverShow = false;
      }
    },

    handleLogout() {
      // 清除登录状态
      clearUserLogin();

      // 关闭下拉菜单
      this.dropdownPopoverShow = false;

      // 跳转到登录页面
      this.$router.push('/auth/login');
    }
  },
};
</script>
